import React from 'react';
import './Overlay.css';

const Overlay = ({children, isOpen, onClose}) => {
  if (!isOpen) return null;

  return (
    <div className="overlay">
      <div className="overlay-backdrop" onClick={onClose}/>
      <div className="overlay-content">
        {children}
      </div>
    </div>
  );
};

export default Overlay;